
import { computed, defineComponent, nextTick, reactive, ref, toRefs, watch, ComputedRef } from 'vue'
import jfschool from '@/api/jfschool'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store'
import Player from '@/components/jfschool/player.vue'
import { DownOutlined, AlignCenterOutlined, PlayCircleFilled, FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons-vue'
import Card from './card.vue'
import Nodata from '@/components/nodata.vue'
import { gotoClientLogin } from '@/utils/stock'
export default defineComponent({
  components: {
    Player,
    DownOutlined,
    AlignCenterOutlined,
    PlayCircleFilled,
    Card,
    Nodata
  },
  setup() {
    type pageDataType = {
      videoInfo: Array<{
        definition?: string
        definitionDesc?: string
        definitionName?: string
        definitionType?: string
        duration?: string
        format?: string
        height?: number
        playURL?: string
        size?: number
        width?: number
      }>
      courseChapterDetailDTOList: any
      expandedKeys: string[]
      treeData: Array<any>
      activeKey: string
      teacherCourse: Array<any>
      introduction: any
      currentLess: any
      courseId: ComputedRef<string> | string
      lessonNo: ComputedRef<string> | string
      theme: string
      playing?: boolean
      breadcrunmb?: Array<{
        title: string
        routename: string
      }>
      videos: Array<any>
      definition?: Array<any>
    }
    const route = useRoute()
    // if (!route.query.token) {
    //   gotoClientLogin()
    // }
    const pageData: pageDataType = reactive({
      videoInfo: [],
      courseChapterDetailDTOList: [],
      expandedKeys: [],
      treeData: [],
      activeKey: '1',
      teacherCourse: [],
      introduction: {},
      currentLess: {}, // 当前播放的视频信息
      courseId: route.query.courseNo as string,
      lessonNo: route.query.lessonNo as string,
      theme: (route.query.theme as string) || 'theme',
      playing: false,
      breadcrunmb: [],
      definition: [],
      videos: []
    })
    // pageData.courseId = computed(() => {
    //   return route.query.courseNo as string
    // })
    // watch(() => pageData.le)
    watch(
      () => [route.query.courseNo],
      () => {
        pageData.lessonNo = ''
        pageData.courseId = route.query.courseNo as string
      }
    )
    const replaceFields = reactive([
      {
        title: 'lessonName',
        children: 'lessonDetailDTOList'
      }
    ])
    function getCourseDtail() {
      const data: any = {}
      data.data = {
        courseNo: pageData.courseId
      }
      const _signature: any = []
      for (const key in data.data) {
        _signature.push(data.data[key])
      }
      const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
      data.headers = {
        token: route.query.token,
        clienttype: 'pc',
        appVersion: store.state.pcqueryInfo.appversion,
        appcode: store.state.pcqueryInfo.appcode,
        serverId: store.state.pcqueryInfo.serverid,
        timestamp: _time,
        signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
      }
      jfschool.getCourseDtail(data).then((res: any) => {
        if (!res) return
        const result = res.data || {}
        pageData.introduction = result

        if (((result || {}).courseChapterDetailDTOList || []).length) {
          result.courseChapterDetailDTOList.forEach((item: any, n: number) => {
            if ((item.lessonDetailDTOList || []).length) {
              item.lessonDetailDTOList.forEach((less: any, i: number) => {
                less.title = less.lessonName
                less.key = less.lessonNo
                less.index = i
              })
            }
            item.children = item.lessonDetailDTOList || []
            item.title = item.chapterName || ''
            item.key = item.chapterNo
            if (n === 0) {
              pageData.expandedKeys = [item.key]
            }
          })
        }
        pageData.treeData = result.courseChapterDetailDTOList || []
        if (pageData.treeData.length) {
          if (pageData.lessonNo) {
            const treeData = result.courseChapterDetailDTOList.map((item: any) => item.lessonDetailDTOList).flat()
            const currentless = (treeData || []).filter((item: any) => {
              return item && (item.lessonNo === pageData.lessonNo || item.chapterNo === pageData.lessonNo || item.subCourseNo === pageData.lessonNo)
            })
            pageData.currentLess = currentless[0]
            pageData.expandedKeys = [pageData.currentLess.chapterNo]
          } else {
            pageData.currentLess = (((result.courseChapterDetailDTOList || [])[0] || {}).lessonDetailDTOList || [])[0] || {}
          }
          getVideoUrl(pageData.currentLess)
        } else {
          pageData.videoInfo = []
          pageData.currentLess = {}
        }
        getTeacherCourse(result.mainTeacherNo)
      })
    }
    // 老师学堂课程
    function getTeacherCourse(mainTeacherNo: any) {
      const data: any = {}
      data.data = {
        teacherNo: mainTeacherNo
      }
      const _signature: any = []
      for (const key in data.data) {
        _signature.push(data.data[key])
      }
      const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
      data.headers = {
        token: route.query.token,
        clienttype: 'pc',
        appVersion: store.state.pcqueryInfo.appversion,
        appcode: store.state.pcqueryInfo.appcode,
        serverId: store.state.pcqueryInfo.serverid,
        timestamp: _time,
        signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
      }
      jfschool.getTeacherCourse(data).then((res: any) => {
        const result = res.data
        pageData.teacherCourse = result
      })
    }
    function gotoCourseDetail(p: { courseNo: any; lessonNo: number | string }) {
      pageData.courseId = p.courseNo
      pageData.lessonNo = ''
      delete route.query.lessonNo
      delete route.query.groupName
      const query = JSON.parse(JSON.stringify(route.query))
      query.courseNo = p.courseNo
      router.replace({
        name: 'coursedetail',
        query: query
      })
    }
    // 视频地址
    function getVideoUrl(subCourse: any) {
      const data: any = {}
      data.data = {
        appCode: store.state.pcqueryInfo.appcode,
        courseNo: pageData.courseId,
        subCourseNo: subCourse.lessonNo || subCourse.subCourseNo
      }
      const _signature: any = []
      for (const key in data.data) {
        _signature.push(data.data[key])
      }
      const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
      const fixedStr = route.query.softNameAbbr === 'jfztADV' ? 'q1NwL2YhXlHBgyt7vvGpRi6MPCOAGxqI' : 'Qiw2sBfMw86hugD9OnENgLdp8G8NdKLM'
      data.headers = {
        token: route.query.token,
        clienttype: 'pc',
        appVersion: store.state.pcqueryInfo.appversion,
        appcode: store.state.pcqueryInfo.appcode,
        serverId: store.state.pcqueryInfo.serverid,
        timestamp: _time,
        // signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
        signature: window.Md5.hashStr(fixedStr + _signature.join('') + _time)
      }
      data.softNameAbbr = route.query.softNameAbbr
      jfschool.getCourseVideoUrl(data).then((res: any) => {
        const result = res.data
        // UD 超清 HD 高清 LD
        // pageData.definition = result
        let definition: any = []
        Object.keys(result).forEach((item: any) => {
          // 例：如果高清视频有多个，则优先显示mp4
          if (result[item].length > 1) {
            const mp4video = result[item].filter((v: any) => v.format === 'mp4')
            definition = definition.concat(mp4video)
          } else {
            definition = definition.concat(result[item])
          }
        })
        pageData.videos = definition.reverse()
        pageData.definition = definition.map((item: any) => ({
          definitionType: item.definitionType,
          definitionName: item.definitionName,
          definition: item.definition,
          format: item.format
        }))
        pageData.videoInfo = pageData.videos[0]
        nextTick(() => {
          const dom: any = document.querySelector('.jfschool > main')
          dom.scrollTop = 0
        })
      })
    }
    getCourseDtail()
    function changenode(e: any, data: any) {
      if ((data.node.children || []).length) {
        data.selected = false
        const currenNodeKey = data.node.eventKey
        const expandedKeys = JSON.parse(JSON.stringify(pageData.expandedKeys))
        // 点击整行，展开收起
        if (pageData.expandedKeys.indexOf(currenNodeKey) > -1) {
          expandedKeys.splice(expandedKeys.indexOf(currenNodeKey), 1)
        } else {
          expandedKeys.push(currenNodeKey)
        }
        pageData.expandedKeys = expandedKeys
        return
      }
      if (data.selectedNodes[0].props.lessonNo) {
        pageData.currentLess = data.selectedNodes[0].props
        pageData.lessonNo = pageData.currentLess.lessonNo
      }
      // getVideoUrl(pageData.currentLess)
    }
    function isPlaying(state: boolean) {
      pageData.playing = state
    }
    // 切换清晰度
    function changeDefinition(params: { key: string; currentTime: Date }) {
      const video = pageData.videos.filter((item: any) => {
        item.eventType = 'continuation'
        item.currentTime = params.currentTime
        return item.definitionType === params.key
      })
      pageData.videoInfo = video[0]
    }

    pageData.breadcrunmb = store.state.breadcrumbList

    watch(
      () => [pageData.courseId, pageData.lessonNo],
      (val: any) => {
        if (val[0] || val[1]) {
          getCourseDtail()
        }
      }
    )
    watch(
      () => route.query.theme,
      (val: any) => {
        pageData.theme = val
      }
    )
    return {
      ...toRefs(pageData),
      gotoCourseDetail,
      changenode,
      isPlaying,
      changeDefinition
    }
  }
})
